import React, { Component }  from 'react';

class Config{
	/*
	jenis layanan: 1 home care, ambulance 2, laboratorium 3, obat 4
	*/
	get_site_info(){
		return {
			name: 'Ranisha Clinic',
			logo: process.env.PUBLIC_URL + "/logo_app.png",
			logo_landscape: process.env.PUBLIC_URL + "/logo_landscape.png",
			description: 'Ranisha Clinic'
		}
	}

	get_server_url(){
		return 'https://api-ranisha.proitdev.com';
	}
	
	get_base_url(){
		return 'https://api-clinic.proitdev.com';
	}

	get_web_socket(){
		return 'wss://api-slamet.proitdev.com/messages/provider/';
	}

	get_cookie_name(){
		return 'r4n4os_cr4uth';
	}

	stripTags(teks){
		return teks.replace(/(<([^>]+)>)/ig, "");//strip tags html
	}

	escape_str(value){
		return(
			<div>
				{value.includes("https://") || value.includes("http://") || value.includes("www.")
					?
						<div>
								<a href={value} target="_blank">{value}</a>
						</div>
					:
						value
				}
			</div>
		);
	}

	cm_to_pixel(cm){
		return cm*37.7952755906;
	}
}
export default Config
